import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/api";
import { CountryResponse } from "../../types/country";


export const getCountries = createAsyncThunk<
  CountryResponse[],          
  void,           
  { rejectValue: string }    
>(
  "country/getCountries",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`locations/get-countries`);

      if (response.data.Data) {
        return response.data.Data as CountryResponse[];
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);



